import { ChevronDown } from "lucide-react";
import { useState } from "react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "¿Dónde tapear en Sevilla Este?",
      answer:
        "Abacería Como en Casa es el lugar perfecto para tapear en Sevilla Este. Ubicados en el Mercado de Abastos, ofrecemos tapas gourmet, ibéricos de bellota, montaditos creativos y una amplia selección de vinos de diferentes denominaciones de origen.",
    },
    {
      question: "¿Dónde tomar vino en Sevilla Este?",
      answer:
        "En Abacería Como en Casa contamos con una bodega cuidadosamente seleccionada con vinos de Rioja, Ribera del Duero, Bierzo, Valencia, Campo de Borja, Ribeiro, Portugal y Jerez. Además, organizamos catas de vino mensuales dirigidas por profesionales.",
    },
    {
      question: "¿Hay restaurantes en el mercado de abastos de Sevilla Este?",
      answer:
        "Sí, Abacería Como en Casa está situado en el Mercado de Abastos de Sevilla Este, concretamente en C. Médicos Mundi, 2, 41020 Sevilla. Ofrecemos tapas gourmet, carnes ibéricas a la brasa, mariscos frescos y un ambiente andaluz auténtico.",
    },
    {
      question: "¿Dónde cenar en Sevilla Este?",
      answer:
        "Abacería Como en Casa es una excelente opción para cenar en Sevilla Este. Nuestro horario es: Jueves de 20:00 a 24:00, Viernes y Sábado de 13:00 a 17:00 y de 20:00 a 24:00, y Domingo de 13:00 a 18:00. Te recomendamos reservar mesa.",
    },
    {
      question: "¿Cómo reservar mesa en Abacería Como en Casa?",
      answer:
        "Puedes reservar mesa de varias formas: llamando al 672 72 99 57, enviando un WhatsApp al mismo número, o rellenando el formulario de reservas en nuestra web. Te recomendamos reservar con antelación, especialmente los fines de semana.",
    },
    {
      question: "¿Qué tipo de cocina ofrece Abacería Como en Casa?",
      answer:
        "Ofrecemos gastronomía española de calidad: tapas gourmet, montaditos creativos (Piripi, Solomillo al whisky, Queso roll), ibéricos de bellota 100% (jamón, lomo, chorizo), carnes a la brasa (solomillo ibérico, secreto, entrecot retinto), pescados y mariscos frescos de la costa andaluza.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section-padding bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-accent text-[#800020] text-lg mb-4">
            Resolvemos tus dudas
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="font-body text-[#1A1A1A]/70">
            Todo lo que necesitas saber sobre tapear y cenar en Sevilla Este
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-[#DCD7CC] bg-[#F9F7F2]"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left"
                aria-expanded={openIndex === index}
                data-testid={`faq-button-${index}`}
              >
                <h3 className="font-heading text-lg text-[#1A1A1A] pr-4">
                  {faq.question}
                </h3>
                <ChevronDown
                  size={20}
                  className={`text-[#800020] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-6 pb-6 font-body text-[#1A1A1A]/80 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center">
          <p className="font-body text-[#1A1A1A]/70 mb-4">
            ¿Tienes más preguntas?
          </p>
          <a
            href="tel:+34672729957"
            data-testid="faq-call-btn"
            className="btn-secondary inline-block"
          >
            Llámanos al 672 72 99 57
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
